// extracted by mini-css-extract-plugin
export var fullWidthButton = "_sc-0";